export default function wrapCallback(callback, event) {
  if (!callback || typeof callback !== 'function') {
    return null;
  }
  return () => {
    callback(event);
  };
}